import { DatePipe, DecimalPipe, NgClass, NgFor } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, computed, effect, HostListener, inject, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CdTimerComponent, CdTimerModule } from 'angular-cd-timer';
import _ from 'lodash';
import { environment } from 'src/environments/environment';
import { NzBreadCrumbComponent, NzBreadCrumbItemComponent } from 'ng-zorro-antd/breadcrumb';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDescriptionsComponent, NzDescriptionsItemComponent } from 'ng-zorro-antd/descriptions';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzPageHeaderBreadcrumbDirective, NzPageHeaderComponent, NzPageHeaderContentDirective, NzPageHeaderExtraDirective, NzPageHeaderTagDirective } from 'ng-zorro-antd/page-header';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzTrDirective } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Subject, takeUntil } from 'rxjs';
import { PermissionService } from 'src/app/core/services/permission.service';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { ArticleFeatureValueDto } from 'src/app/shared/dto/article-feature-value.dto';
import { ConfigurationDto } from 'src/app/shared/dto/configuration.dto';
import { FinalProductDto } from 'src/app/shared/dto/final-product.dto';
import { LossDto } from 'src/app/shared/dto/loss.dto';
import { MachineMeasurementsValueDto } from 'src/app/shared/dto/machine-measurements-value.dto';
import { MachineDto } from 'src/app/shared/dto/machine.dto';
import { ProductionOrderProcessDto } from 'src/app/shared/dto/production-order-process.dto';
import { ProductionOrderDto } from 'src/app/shared/dto/production-order.dto';
import { ProductionPauseDto } from 'src/app/shared/dto/production-pause.dto';
import { ProductionTimeDto } from 'src/app/shared/dto/production-time.dto';
import { ScrapDto } from 'src/app/shared/dto/scrap.dto';
import { SensorDto } from 'src/app/shared/dto/sensor.dto';
import { SetEndDateParams } from 'src/app/shared/dto/set-end-date-params.dto';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { ConfigurationTypesEnum } from 'src/app/shared/enums/configuration-types.enum';
import { ConfigurationKeysEnum } from 'src/app/shared/enums/configuration-keys.enum';
import { CustomErrorStatusesEnum } from 'src/app/shared/enums/custom-error-statuses.enum';
import { MachineStatesEnum } from 'src/app/shared/enums/machine-states.enum';
import { StatusEnum } from 'src/app/shared/enums/production-order-state-ids.enum';
import { LossOrScrapSourceEnum } from 'src/app/shared/enums/loss-or-scrap-source.enum';
import { ModalCreateLossesComponent } from '../../components/modals/modal-create-losses/modal-create-losses.component';
import { ModalCreatePauseComponent } from '../../components/modals/modal-create-pause/modal-create-pause.component';
import { ModalCreateScrapsComponent } from '../../components/modals/modal-create-scraps/modal-create-scraps.component';
import { ModalFinalProductsByOrderProcessComponent } from '../../components/modals/modal-final-products-by-order-process/modal-final-products-by-order-process.component';
import { ModalPrintStickersComponent } from '../../components/modals/modal-print-stickers/modal-print-stickers.component';
import { ModalQualityControlComponent } from '../../components/modals/modal-quality-control/modal-quality-control.component';
import { ModalQuantityProducedComponent } from '../../components/modals/modal-quantity-produced/modal-quantity-produced.component';
import { ModalSelectFinalProductsComponent } from '../../components/modals/modal-select-final-products/modal-select-final-products.component';
import { ModalTraceabilityByOrderProcessComponent } from '../../components/modals/modal-traceability-by-order-process/modal-traceability-by-order-process.component';
import { ModalWatchLossesComponent } from '../../components/modals/modal-watch-losses/modal-watch-losses.component';
import { ModalWatchPausesComponent } from '../../components/modals/modal-watch-pauses/modal-watch-pauses.component';
import { ModalWatchScrapsComponent } from '../../components/modals/modal-watch-scraps/modal-watch-scraps.component';
import { ArticleBatchesService } from '../../services/article-batches.service';
import { ArticlesService } from '../../services/articles.service';
import { ConfigurationService } from '../../services/configuration.service';
import { MachineService } from '../../services/machine.service';
import { ProductionOrderProcessesService } from '../../services/production-order-processes.service';
import { FinalProductService } from '../../services/final-product.service';
import { PackagingsService } from '../../services/packagings.service';
import { SensorsService } from '../../services/sensors.service';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SensorCardComponent } from '../../components/sensor-card/sensor-card.component';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { ModalSelectOriginComponent } from '../../components/modals/modal-select-origin-component/modal-select-origin.component';
import { ModalOrderProcessOperatorsHistoryComponent } from '../../components/modals/modal-order-process-operators-history/modal-order-process-operators-history.component';
import { RawMaterialToUseDto } from 'src/app/shared/dto/raw-material-to-use.dto';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { SensorValueDto } from 'src/app/shared/dto/sensor-value.dto';
import { ModalRawMaterialsToUseComponent } from '../../components/modals/modal-raw-materials-to-use/modal-raw-materials-to-use.component';
import { MachineMeasurementsEnum } from 'src/app/shared/enums/machine-measurements.enum';
import { StopActionsEnum } from 'src/app/shared/enums/stop-actions.enum';
import { UserService } from '../../services/user.service';
import { ModalUsedRawMaterialsComponent } from '../../components/modals/modal-used-raw-materials/modal-used-raw-materials.component';
import { ProductionOrderProcessFeatureDto } from 'src/app/shared/dto/production-order-process-feature.dto';
import { getLastError, isMmlProcessName, getDisplayUnit, isUdProcessName } from '../../../shared/utils/utils';
import { PackagingDestinationTypeEnum } from 'src/app/shared/enums/packaging-destination-type.enum';
import { ModalSelectPackagingDestinationComponent } from '../../components/modals/modal-select-packaging-destination/modal-select-packaging-destination.component';
import { ModalPalletListComponent } from '../../components/modals/modal-pallet-list/modal-pallet-list.component'; 
import { ModalScanRawMaterialComponent } from '../../components/modals/modal-scan-raw-material/modal-scan-raw-material.component';
import { ModalApplyTempLoadedRawMaterialsComponent } from '../../components/modals/modal-apply-temp-loaded-raw-materials/modal-apply-temp-loaded-raw-materials.component';
import { ArticleDto } from 'src/app/shared/dto/article.dto';
import { ArticleBatchDto } from 'src/app/shared/dto/article-batch.dto';
import { PackagingDto } from 'src/app/shared/dto/packaging.dto';
import { RawMaterialDto } from 'src/app/shared/dto/rawMaterial.dto';
import { ShiftSessionsService } from '../../services/shift-sessions.service';
import { CheckActiveSessionResponseDto } from 'src/app/shared/dto/check-active-session-response.dto';
interface PlainRawMaterial {
    rawMaterialToUseId?: number;
    description?: string;
    article?: ArticleDto;
    articleBatch?: ArticleBatchDto;
    packaging?: PackagingDto;
    measurementUnit?: string;
    quantity: number;
    isLoadedOnMachine: boolean;
    articleFamily?: string;
}


@Component({
    selector: 'app-production-order-process-detail',
    templateUrl: './production-order-process-detail.component.html',
    styleUrl: './production-order-process-detail.component.scss',
    standalone: true,
    imports: [
        NzPageHeaderComponent,
        NzPageHeaderExtraDirective,
        CdTimerModule,
        NzCollapseModule,
        NzPageHeaderTagDirective,
        NgClass,
        NgFor,
        NzBreadCrumbComponent,
        NzPageHeaderBreadcrumbDirective,
        NzBreadCrumbItemComponent,
        RouterLink,
        NzPageHeaderContentDirective,
        NzDescriptionsComponent,
        NzDescriptionsItemComponent,
        NzTableComponent,
        NzTableCellDirective,
        NzTbodyComponent,
        NzTheadComponent,
        NzTrDirective,
        DatePipe,
        DecimalPipe,
        NzMessageModule,
        NzModalModule,
        NzColDirective,
        NzRowDirective,
        NzProgressModule,
        NzToolTipModule,
        SensorCardComponent,
        LoaderComponent,
        NzCardComponent,
        NzTagModule,
        NzIconModule,
        ModalApplyTempLoadedRawMaterialsComponent
    ]
})

export class ProductionOrderProcessDetailComponent implements OnInit, OnDestroy, AfterViewInit {
    idOrder: number;
    idOrderProcess: number;
    currentPause: ProductionPauseDto | null = null;
    productionTime: ProductionTimeDto = new ProductionTimeDto();
    order!: ProductionOrderDto;
    orderProcess!: ProductionOrderProcessDto;
    StatusEnum = StatusEnum;
    LossOrScrapSourceEnum = LossOrScrapSourceEnum;
    machineMeasurements: MachineMeasurementsValueDto[] = [];
    articleFeatureValues: ArticleFeatureValueDto[] = [];
    configurations: ConfigurationDto[] = [];

    timeLoaded: boolean = false;
    processInitiated: boolean = false;
    isLoading: boolean = true;
    isQualityControlActivated: boolean = false;
    qualityControlPerSeconds: number = 0;
    qualityControlPerQuantityProduced: number = 0;
    showingQualityControl: boolean = false;
    isGenerateNewLabelButtonEnabled: boolean = true;
    machines: MachineDto[] = [];
    machineProcess: MachineDto | undefined;
    stopAction = signal<StopActionsEnum | null>(null);
    isCurrentUserAssignedToProcess = signal<boolean>(false);
    hasActiveShiftSession = signal<boolean>(false);
    productionOrderProcessFeatures: ProductionOrderProcessFeatureDto[] = [];
    basicRawMaterial: PlainRawMaterial = {
        quantity: 0,
        isLoadedOnMachine: false
    };

    // KPIs
    quantityToProduce = signal(0);
    multiplier = signal(1); //TODO CAMBIAR MOTIVO ANCHO
    linearMeters = signal(0);

    private quantityProduced = signal(0);
    private velocity = signal(0);

    private remainingQuantity = computed(() => {
        return this.quantityToProduce() - this.quantityProduced();
    });

    private estimatedTime = computed(() => {
        if (this.velocity() > 0) {
            const result = (this.remainingQuantity() / this.velocity() / this.multiplier()) * 60;
            return result > 0 ? result : 0;
        }

        return 0;
    });

    quantitiesConsumedMap = signal<Map<number, number>>(new Map());

    sensorsValuesMap: Map<number, SensorValueDto> = new Map();

    @ViewChild('basicTimer', { static: false }) timer!: CdTimerComponent;
    userLogged!: UserDto;

    innerWidth: number = 0;

    idColumnValueToShow: string = 'id';
    orderProcessTitle: string = '';
    idValueToShow: string = '';

    panels: { active: boolean, type: string, name: string, hidden: boolean }[] = [
        {
            active: true,
            type: 'finalProducts',
            name: 'Detalles productos finales',
            hidden: true
        },
        {
            active: false,
            type: 'articleFeatures',
            name: 'Características productos finales',
            hidden: true
        },
        {
            active: false,
            type: 'machineMeasurements',
            name: 'Valores de máquina',
            hidden: true
        }
    ];

    private sensorConfigKey: string = 'productionOrdersProcessesDetail.sensors';
    private modalPauseOpened: boolean = false;
    private loadMachineMeasurementValues: boolean = true;
    private lastAccumulatedSensorValue: number = 0;
    private productionOrderFinalQuantity: string = 'productionOrder.final.quantity';
    private productionOrdermultipleMachinesRunning: string = 'productionOrders.multipleMachinesRunning';

    private unsubscribe$ = new Subject<void>();

    /**
     * Devuelve la unidad de medida a mostrar según el proceso de producción
     */
    getDisplayUnit(): string {
        return getDisplayUnit(
            this.orderProcess?.productionProcessId,
            this.orderProcess?.productionProcess?.name,
            this.orderProcess?.finalProducts?.[0]?.article?.measurementUnit?.abbreviation || ''
        );
    }

    private readonly activeRoute = inject(ActivatedRoute);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly permissionService = inject(PermissionService);
    private readonly productionOrderProcessesService = inject(ProductionOrderProcessesService);
    private readonly finalProductService = inject(FinalProductService);
    private readonly packagingsService = inject(PackagingsService);
    private readonly modalService = inject(NzModalService);
    private readonly toast = inject(NzMessageService);
    private readonly articleService = inject(ArticlesService);
    private readonly articleBatchService = inject(ArticleBatchesService);
    private readonly sensorsService = inject(SensorsService);
    private readonly configurationService = inject(ConfigurationService);
    private readonly machineService = inject(MachineService);
    private readonly usersService = inject(UserService);
    private readonly shiftSessionsService = inject(ShiftSessionsService);

    constructor() {
        this.idOrder = parseInt(this.activeRoute.snapshot.params['idOrder']);
        this.idOrderProcess = parseInt(this.activeRoute.snapshot.params['idOrderProcess']);
        this.userLogged = _.cloneDeep(this.userLoggedService.userLogged);

        if (!this.idOrder || this.idOrder < 0 || !this.idOrderProcess || this.idOrderProcess < 0 || !this.userLogged) {
            throw new Error('Algo ha ido mal obteniendo el id de la orden, del proceso o el usuario logueado.');
        }

        //Sensor velocity
        effect(() => {
            const v = this.velocity();
            const sensors = this.orderProcess?.machine?.sensors;

            if (!sensors || sensors.length === 0 || !this.orderProcess?.id) {
                return;
            }

            if (sensors && sensors.length > 0 && sensors[2]) {
                sensors[2].value = v;
            }
        });

        //Sensor remainingQuantity
        effect(() => {
            const rq = this.remainingQuantity() >= 0 ? this.remainingQuantity() : 0;
            const sensors = this.orderProcess?.machine?.sensors;

            if (!sensors || sensors.length === 0 || !this.orderProcess?.id) {
                return;
            }

            if (sensors && sensors.length > 0 && sensors[5]) {
                sensors[5].value = this.quantityProduced();
            }

            if (sensors && sensors.length > 0 && sensors[6]) {
                sensors[6].value = rq;
            }
        });

        effect(() => {
            const produced = this.quantityProduced();
            const multiplier = this.multiplier();

            this.updateConsumedQuantitiesMap(produced, multiplier);
        }, { allowSignalWrites: true });
    }

    @HostListener('window:resize')
    onResize() {
        this.innerWidth = window.innerWidth;
    }

    async ngOnInit(): Promise<void> {
        try {
            this.innerWidth = window.innerWidth;
            await this.sensorsService.setupWebSocket();

            await this.productionOrderProcessesService.setupWebSocket(this.idOrderProcess);

            this.productionOrderProcessesService.orderProcess$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: async (orderProcess) => {
                        if (!orderProcess || (orderProcess && !orderProcess.productionOrder)) {
                            this.isLoading = false;
                            throw new Error(`No se ha encontrado el proceso ${this.idOrderProcess} en la orden ${this.idOrder}`);
                        }

                        this.orderProcess = _.cloneDeep(orderProcess);
                        this.updateConsumedQuantitiesMap(this.quantityProduced(), this.multiplier());
                        this.order = _.cloneDeep(orderProcess.productionOrder!);
                        this.quantityToProduce.set(this.orderProcess.finalProducts!.reduce((acc, fp) => acc + (fp.quantityToProduce || 0), 0));
                        await this.handleTimerAndStatus();
                        this.loadMultiplier();
                        this.checkUserAssignmentToProcess(orderProcess);
                        if (this.orderProcess.finalProducts && this.orderProcess.finalProducts.length > 0) {
                            this.panels.find((panel: { active: boolean, type: string, name: string, hidden: boolean }) => panel.type == 'finalProducts')!.hidden = false;
                            this.articleFeatureValues = [];

                            for (const finalProduct of this.orderProcess.finalProducts) {
                                this.articleFeatureValues.push(...finalProduct.article?.articleFeatureValues!);
                            }
                        } else {
                            this.panels.find((panel: { active: boolean, type: string, name: string, hidden: boolean }) => panel.type == 'finalProducts')!.hidden = true;
                        }

                        if (orderProcess.sensorValues && orderProcess.sensorValues.length > 0) {
                            const sensorValues: SensorValueDto[] = orderProcess.sensorValues;

                            if (sensorValues && sensorValues.length > 0) {
                                const isMachineRunning: boolean = sensorValues[1].value && sensorValues[1].value === 1 ? true : false;

                                if (!isMachineRunning) {
                                    this.velocity.set(0);
                                } else if (sensorValues.length > 2 && sensorValues[2].value && sensorValues[2].value > 0) {
                                    this.velocity.set(sensorValues[2]?.value ?? 0);
                                }

                                this.lastAccumulatedSensorValue = sensorValues.length > 5 ? sensorValues[5]?.value ?? 0 : 0;

                                if (this.lastAccumulatedSensorValue > 0 && this.quantityProduced() === 0) {
                                    this.quantityProduced.set(this.lastAccumulatedSensorValue * this.multiplier());
                                }

                                if (this.orderProcess.finalProducts && this.orderProcess.finalProducts.length > 0) {
                                    this.orderProcess.finalProducts[0].quantityProduced = this.quantityProduced();
                                }


                            }
                        }

                        if (this.orderProcess.machineId && this.loadMachineMeasurementValues) {
                            const articleIds: number[] = (this.orderProcess.finalProducts && this.orderProcess.finalProducts.length > 0) ? this.orderProcess.finalProducts.flatMap(finalProduct => finalProduct.article?.id!) : [];
                            this.machineMeasurements = await this.productionOrderProcessesService.getMachineMeasurementValues(this.orderProcess.productionProcess.id, this.orderProcess.machineId, articleIds);

                            this.loadMachineMeasurementValues = false;
                        }

                        if (this.machineMeasurements.length > 0) {
                            this.panels.find((panel: { active: boolean, type: string, name: string, hidden: boolean }) => panel.type == 'machineMeasurements')!.hidden = false;
                        } else {
                            this.panels.find((panel: { active: boolean, type: string, name: string, hidden: boolean }) => panel.type == 'machineMeasurements')!.hidden = true;
                        }

                        if (this.articleFeatureValues.length > 0) {
                            this.panels.find((panel: { active: boolean, type: string, name: string, hidden: boolean }) => panel.type == 'articleFeatures')!.hidden = false;
                        } else {
                            this.panels.find((panel: { active: boolean, type: string, name: string, hidden: boolean }) => panel.type == 'articleFeatures')!.hidden = true;
                        }

                        if (this.orderProcess.id) {
                            await this.productionOrderProcessesService.getProductionOrderProcessFeatures(
                                this.orderProcess.id
                            ).then(features => {
                                this.productionOrderProcessFeatures.push(...features);
                            });
                        }
                    },
                    error: () => {
                        this.toast.error('Error cargando la orden de producción');
                    }
                });

            this.configurations = await this.configurationService.getConfigurations();

            const generateNewLabelButtonConfig: ConfigurationDto | undefined = this.configurations.find(
                (c) => c.key === ConfigurationKeysEnum.PRODUCTION_ORDERS_GENERATE_NEW_LABEL_BUTTON_ENABLED
            );

            if (generateNewLabelButtonConfig && generateNewLabelButtonConfig.type === ConfigurationTypesEnum.BOOLEAN) {
                this.isGenerateNewLabelButtonEnabled = generateNewLabelButtonConfig.value === true || generateNewLabelButtonConfig.value === 'true';
            }

            const qualityControlActiveConfig: ConfigurationDto | undefined = this.configurations.find(
                (c) => c.key === 'qualityControl.activated'
            );

            if (qualityControlActiveConfig != null && qualityControlActiveConfig.type === ConfigurationTypesEnum.BOOLEAN) {
                this.isQualityControlActivated = JSON.parse(qualityControlActiveConfig.value as string);
                if (this.isQualityControlActivated) {
                    const qualityControlMinutesConfig: ConfigurationDto | undefined = this.configurations.find(
                        (c) => c.key === 'qualityControl.delayInSeconds'
                    );

                    if (qualityControlMinutesConfig != null && qualityControlMinutesConfig.type === ConfigurationTypesEnum.NUMBER) {
                        this.qualityControlPerSeconds = +qualityControlMinutesConfig.value;
                    }

                    const qualityControlQuantityProducedConfig: ConfigurationDto | undefined = this.configurations.find(
                        (c) => c.key === 'qualityControl.delayInQuantityProduced'
                    );

                    if (qualityControlQuantityProducedConfig != null && qualityControlQuantityProducedConfig.type === ConfigurationTypesEnum.NUMBER) {
                        this.qualityControlPerQuantityProduced = +qualityControlQuantityProducedConfig.value;
                    }
                }
            }

            const useSensorConfig: ConfigurationDto = await this.configurationService.getConfigurationByKey(this.sensorConfigKey);

            if (useSensorConfig.type === ConfigurationTypesEnum.BOOLEAN && JSON.parse(useSensorConfig.value as string)) {
                this.sensorsService.machineSensors$
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe({
                        next: (sensor: SensorDto) => {
                            if (sensor == undefined || this.idOrderProcess !== +sensor.orderProcessId || this.orderProcess.machineId !== +sensor.machineId) {
                                return;
                            }

                            const sensors = this.orderProcess.machine?.sensors;

                            if (!sensors) {
                                return;
                            }

                            const sensorIndex = sensors.findIndex(s => s.id === sensor.id);

                            if (sensorIndex < 0) {
                                return;
                            }

                            switch (sensorIndex) {
                                case 2: // Cortes
                                    this.velocity.set(sensor.value ?? 0);
                                    sensors[2].value = this.velocity();
                                    break;
                                case 5: // Acumulado cortes
                                    if (sensor.value && sensor.value > 0) {
                                        this.quantityProduced.set((sensor.value + this.lastAccumulatedSensorValue) * this.multiplier());
                                        sensors[5].value = this.quantityProduced();

                                        if (this.orderProcess.finalProducts) {
                                            this.orderProcess.finalProducts[0].quantityProduced = this.quantityProduced();
                                        }

                                        const recalculatedRemaining = this.remainingQuantity();
                                        sensors[6].value = recalculatedRemaining >= 0 ? recalculatedRemaining : 0;
                                    }

                                    break;
                                default:
                                    break;
                            }
                        }
                    });
            }

            await this.machineService.setupWebSocket();
            this.machineService.machines$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (machines) => {
                        this.machines = machines;
                        this.machineProcess = this.machines.find((machine) => machine.id === this.orderProcess.machineId);
                    },
                    error: () => {
                        this.toast.error('Error cargando las máquinas');
                    }
                });

            this.idColumnValueToShow = (await this.configurationService.getConfigurationByKey('order.idColumnValue')).value.toString() ?? 'id';

            this.orderProcessTitle = this.getNzTitle();

            this.isLoading = false;
        } catch (e: any) {
            this.toast.error(`${e.message}`);
        }
    }

    async ngAfterViewInit() {
        this.innerWidth = window.innerWidth;
        const interval = setTimeout(async () => {
            if (this.timer) {
                await this.setTimer();
            }
        }, 900); // Espera 900 ms

        // Comprobar materias primas temporales tras inicialización
        setTimeout(async () => {
            await this.checkTempLoadedRawMaterials();
        }, 1200);
    }

    private async checkTempLoadedRawMaterials(): Promise<void> {
        try {
            if (!this.orderProcess || !this.orderProcess.machineId) {
                return;
            }

            const tempLoadedRawMaterials = await this.productionOrderProcessesService.getTempLoadedRawMaterialsByMachine(this.orderProcess.machineId);

            if (tempLoadedRawMaterials && tempLoadedRawMaterials.length > 0) {
                // Comparar como multiconjuntos (contar duplicados) para asegurarnos de coincidencia exacta
                const tempArticleCountsByArticleId = new Map<number, number>();
                tempLoadedRawMaterials.forEach((loadedItem: any) => {
                    const articleId = loadedItem?.rawMaterialUsed?.article?.id ?? loadedItem?.rawMaterialToUse?.articleId;
                    if (articleId && articleId > 0) {
                        const previousCount = tempArticleCountsByArticleId.get(articleId) ?? 0;
                        tempArticleCountsByArticleId.set(articleId, previousCount + 1);
                    }
                });

                const processArticleCountsByArticleId = new Map<number, number>();
                (this.orderProcess?.rawMaterialsToUse ?? []).forEach((rawMaterialToUse: RawMaterialToUseDto) => {
                    const articleId = rawMaterialToUse?.articleId ?? rawMaterialToUse?.article?.id;
                    if (articleId && articleId > 0) {
                        const previousCount = processArticleCountsByArticleId.get(articleId) ?? 0;
                        processArticleCountsByArticleId.set(articleId, previousCount + 1);
                    }
                });

                let articleMultisetsMatch = true;
                if (tempArticleCountsByArticleId.size !== processArticleCountsByArticleId.size) {
                    articleMultisetsMatch = false;
                } else {
                    for (const [articleId, count] of tempArticleCountsByArticleId) {
                        if ((processArticleCountsByArticleId.get(articleId) ?? 0) !== count) {
                            articleMultisetsMatch = false;
                            break;
                        }
                    }
                }

                if (!articleMultisetsMatch) {
                    // Mostrar advertencia y no abrir el modal cuando no coinciden exactamente
                    this.toast.warning('No se pueden precargar las materias primas porque no coincidene exactamente con las materias primas de la orden anterior.');

                    // Aplicar las materias primas temporales con preload = false (sin abrir el modal)
                    try {
                        const preloadDecisions = tempLoadedRawMaterials
                            .filter((tempLoadedItem: any) => typeof tempLoadedItem.rawMaterialUsedId === 'number')
                            .map((tempLoadedItem: any) => ({ rawMaterialUsedId: tempLoadedItem.rawMaterialUsedId as number, preload: false }));
                        const currentUserId = this.userLogged?.id;
                        const updatedOrderProcess = await this.productionOrderProcessesService.applyLoadedRawMaterialsToProcess(this.idOrderProcess, preloadDecisions, currentUserId as any);

                        if (updatedOrderProcess) {
                            this.orderProcess = updatedOrderProcess;
                            // Mostrar success solo si alguna materia prima se ha marcado para preload (es decir, se ha aplicado)
                            const anyPreloaded = preloadDecisions && preloadDecisions.some((d: any) => d.preload === true);
                            if (anyPreloaded) {
                                this.toast.success('Materias primas aplicadas/actualizadas en el proceso');
                            }
                        }
                    } catch (error: any) {
                        this.toast.error(error?.message || 'Error aplicando materias primas temporales');
                    }

                    return;
                }

                const modal = this.modalService.create({
                    nzContent: ModalApplyTempLoadedRawMaterialsComponent,
                    nzWidth: '80%',
                    nzData: {
                        machineId: this.orderProcess.machineId,
                        orderProcessId: this.idOrderProcess
                    },

                    // Evitar cierre accidental con click fuera; la acción de cancelar ahora muestra confirmación
                    nzClosable: false,
                    nzMaskClosable: false,
                    nzFooter: null
                });

                modal.afterClose.subscribe((result: any) => {
                    if (!result) {
                        return;
                    }

                    let updatedProcess: any = null;
                    let anyPreloaded: boolean = false;

                    if (result && result.updatedProcess) {
                        updatedProcess = result.updatedProcess;
                        anyPreloaded = result.anyPreloaded ?? false;
                    } else {
                        // Modo legacy: si se devuelve directamente el proceso
                        updatedProcess = result;
                        anyPreloaded = true;
                    }

                    if (updatedProcess) {
                        this.orderProcess = updatedProcess;
                        if (anyPreloaded) {
                            this.toast.success('Materias primas aplicadas/actualizadas en el proceso');
                        }
                    }
                });
            }
        } catch (e: any) {
            this.toast.error(e?.message || 'Error comprobando materias primas temporales');
        }
    }
    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.productionOrderProcessesService.disconnectWebSocket(this.idOrderProcess)
        this.sensorsService.disconnectWebSocket();
        this.machineService.disconnectWebSocket();
    }

    showButton(btnName: string): boolean {
        const permissionMainKey: string = 'productionOrderProcessDetail';

        return this.permissionService.canRead(permissionMainKey, `${btnName}`);
    }

    canReadKey(permissionMainKey: string): boolean {

        return this.permissionService.canRead(permissionMainKey, '');
    }

    countSensorsShowInScreen(): number {
        return this.orderProcess.machine?.sensors?.filter(sensor => sensor.showInScreen === true).length ?? 0;
    }

    getUniqueSensor(): SensorDto {
        return this.orderProcess.machine?.sensors?.filter(sensor => sensor.showInScreen === true)[0]!;
    }

    getRawMaterialsWithBatch(): any[] {
        if (!this.orderProcess?.rawMaterialsUsed) {
            return [];
        }

        return this.orderProcess.rawMaterialsUsed.filter(rm =>
            rm.articleBatchId && rm.articleBatchId > 0
        );
    }

    getArticleProductionProcessFeatureValue(rawMaterial: any, featureId: number): string | null {
        let response: any = "0"
        let temp = this.orderProcess?.rawMaterialsToUse.find(rm => rm.article && rm.article.id === rawMaterial.articleId)
        if (temp != null) {
            response = this.productionOrderProcessFeatures.find(f => f.rawMaterialToUseId === temp.id && f.productionOrderProcessFeaturesTypesId === featureId)?.value;
        }
        return response;
    }


    hasAnyRawMaterialWithFeature(featureId: number): boolean {
        const rawMaterials = this.getRawMaterialsWithBatch();
        return rawMaterials.some(rm => this.getArticleProductionProcessFeatureValue(rm, featureId) !== null);
    }

    /**
     * Obtiene el valor del ancho del producto final (feature 23 ) feature de ancho de bolsa en producto final
     * @returns number - El valor del ancho, o 1 si no se encuentra
     */
    private getFinalProducBagtWidth(featureId: number): number {
        let response: any = 1
        if (!this.orderProcess?.finalProducts || this.orderProcess.finalProducts.length === 0) {
            return 1;
        }
        const finalProduct = this.orderProcess.finalProducts[0];
        response = this.productionOrderProcessFeatures.find(f => f.finalProductId === finalProduct.id && f.productionOrderProcessFeaturesTypesId === featureId)?.value;

        return response;
    }

    //TODO: revisar unidades
    /* getRawMaterialLinearMeters(rawMaterial: RawMaterialDto): number {
        if (rawMaterial?.rawMaterialToUseId) {
            const cachedValue = this.quantitiesConsumedMap().get(rawMaterial.rawMaterialToUseId);
            if (cachedValue !== undefined) {
                return cachedValue;
            }
        }

        const width = Number(this.getFinalProducBagtWidth(5));
        return this.calculateLinearMeters(
            rawMaterial,
            this.quantityProduced(),
            this.multiplier(),
            width
        );
    } */

    private calculateLinearMeters(rawMaterial: RawMaterialDto, produced: number, multiplier: number, width: number): number {
        const safeMultiplier = multiplier === 0 ? 1 : multiplier;
        const quantityRawMaterialUsed = this.getTotalQuantityUsedForRawMaterial(rawMaterial);

        if (rawMaterial.rawQuantity && rawMaterial.rawQuantity !== 0) {
            return rawMaterial.rawQuantity;
        }

        if (isNaN(width)) {
            return (produced / safeMultiplier) - quantityRawMaterialUsed;
        }

        return ((produced / safeMultiplier * width) / 1000) - quantityRawMaterialUsed;
    }

    //TODO: revisar unidades
    /* getRawMaterialKg(rawMaterial: any): number {
        const linearMeters = this.getRawMaterialLinearMeters(rawMaterial);
        const featureValue = this.getArticleProductionProcessFeatureValue(rawMaterial, 2);
        const feature = featureValue ? parseFloat(featureValue) : 0;

        if (feature === 0) {
            return 0;
        }

        return (linearMeters * feature) / 1000;;
    } */

    getTotalQuantityUsedForRawMaterial(rawMaterial: any): number { // TODO CAMBIAR A ANY POR RAWMATERIAL DTO
        if (!this.orderProcess?.rawMaterialsUsed) {
            return 0;
        }

        let temp = this.orderProcess.rawMaterialsToUse.find(rm => rm.id === rawMaterial.rawMaterialToUseId);
        if (!temp) return 0;

        let response = this.orderProcess.rawMaterialsUsed
            .filter(rm => rm.rawMaterialToUseId === temp.id)
            .reduce((total, rm) => total + (rm.rawQuantity || 0), 0);
        return response;
    }

    private updateConsumedQuantitiesMap(produced: number, multiplier: number): void {
        const rawMaterials = this.orderProcess?.rawMaterialsUsed;

        if (!rawMaterials?.length) {
            this.quantitiesConsumedMap.set(new Map());
            return;
        }

        rawMaterials.forEach(rawMaterial => {
            if (!rawMaterial.rawMaterialToUseId) {
                return;
            }
            const quantityRawMaterialUsed = this.getTotalQuantityUsedForRawMaterial(rawMaterial);
            this.quantitiesConsumedMap().set(rawMaterial.rawMaterialToUseId, produced - quantityRawMaterialUsed);
        });
    }

    openRawMaterialsToUseModal() {
        const modal = this.modalService.create({
            nzContent: ModalRawMaterialsToUseComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Materias a utilizar - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                productionProcessId: this.orderProcess.productionProcess.id,
                orderProcess: this.orderProcess,
                rawMaterialsUsed: this.orderProcess?.rawMaterialsUsed,
                rawMaterialsToUse: this.orderProcess?.rawMaterialsToUse,
                finalProducts: this.orderProcess?.finalProducts,
                consumedQuantitiesSignal: this.quantitiesConsumedMap
            }
        });
    }

    openUsedRawMaterialsModal() {
        const modal = this.modalService.create({
            nzContent: ModalUsedRawMaterialsComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Materias primas utilizadas - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                orderProcess: this.orderProcess,
                rawMaterialsToUse: this.orderProcess?.rawMaterialsToUse,
                finalProducts: this.orderProcess?.finalProducts,
                isFromOrderProcessDetail: true
            }
        });

        modal.componentInstance?.emitService.subscribe(async (modifiedRawMaterialsToUse: RawMaterialToUseDto[]) => {

            this.orderProcess.rawMaterialsToUse = modifiedRawMaterialsToUse;

            await this.productionOrderProcessesService.updateRawMaterialsToUse(this.orderProcess.id!, modifiedRawMaterialsToUse);

            this.toast.success('Materias primas a utilizar actualizadas correctamente');

            modal.close();
        });
    }

    openPausesModal() {
        this.modalService.create({
            nzContent: ModalWatchPausesComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Ver pausas - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                orderProcess: this.orderProcess
            }
        });
    }

    openScrapsModal() {
        this.modalService.create({
            nzContent: ModalWatchScrapsComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Ver taras - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                scraps: this.orderProcess?.scraps,
                productionProcessId: this.orderProcess?.productionProcessId
            }
        });
    }

    openCreateScrapsModal() {
        const modal = this.modalService.create({
            nzContent: ModalCreateScrapsComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Nueva tara - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                processId: this.orderProcess?.id,
                finalProducts: this.orderProcess.finalProducts
            }
        });

        modal.componentInstance?.emitService.subscribe(async (value: ScrapDto) => {
            this.orderProcess.scraps?.push(value);
            this.order.productionOrderProcesses = this.order.productionOrderProcesses?.map((p) => {
                if (p.id === this.orderProcess.id) {
                    p = this.orderProcess;
                }

                return p;
            });

            this.toast.success('Tara creada correctamente');
        });
    }

    openLossesModal() {
        this.modalService.create({
            nzContent: ModalWatchLossesComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Ver mermas - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                losses: this.orderProcess?.losses
            }
        });
    }

    openCreateLossesModal() {
        const modal = this.modalService.create({
            nzTitle: 'Seleccionar origen de la merma',
            nzContent: ModalSelectOriginComponent,
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
        });

        const instance = modal.getContentComponent();
        instance?.originSelected.subscribe((origin: LossOrScrapSourceEnum) => {
            modal.close();
            this.openCreateLossesModalWithOrigin(origin);
        });
    }

    openCreateLossesModalWithOrigin(origin: LossOrScrapSourceEnum) {
        const modal = this.modalService.create({
            nzContent: ModalCreateLossesComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Nueva merma - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                processId: this.orderProcess?.id,
                origin: origin,
                rawMaterials: origin === LossOrScrapSourceEnum.RAW_MATERIAL ? this.orderProcess?.rawMaterialsUsed : [],
                finalProducts: origin === LossOrScrapSourceEnum.FINAL_PRODUCT ? this.orderProcess?.finalProducts : []
            }
        });

        modal.componentInstance?.emitService.subscribe(async (value: LossDto) => {
            this.toast.success('Merma creada correctamente');
        });

        // Mostrar mensaje para mermas de producto final en Samarplast
        if (origin === LossOrScrapSourceEnum.FINAL_PRODUCT && environment.apiUrl.includes('samarplast')) {
            this.toast.info('Recordatorio: Las mermas del producto final se distribuyen entre las bobinas ya utilizadas. Se recomienda finalizar la orden de producción antes de registrar mermas.');
        }
    }

    openPrintStickersModal() {
        this.modalService.create({
            nzContent: ModalPrintStickersComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                data: {
                    processId: this.orderProcess?.id,
                    processDescription: this.orderProcess?.description,
                    packagings: this.orderProcess.finalProducts?.map(fp => fp.packagings)?.flat(1)
                }
            }
        });
    }

    openOperatorHistoryModal() {
        this.modalService.create({
            nzContent: ModalOrderProcessOperatorsHistoryComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Histórico de operadores - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                orderProcessId: this.orderProcess?.id
            }
        })
    }

    pauseProcess() {
        if (!this.processInitiated) {
            this.toast.error('No se puede pausar una orden que no ha sido iniciada');
            return;
        }

        if (this.productionTime?.endDate) {
            this.toast.error('La producción ya ha sido finalizada');
            return;
        }

        if (this.currentPause != null) {
            this.toast.error('Ya hay una pausa en curso');
            return;
        }

        if (!this.timeLoaded) {
            return;
        }

        if (this.modalPauseOpened) {
            return;
        }

        this.modalPauseOpened = true;

        const modal = this.modalService.create({
            nzContent: ModalCreatePauseComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Nueva pausa - Orden ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                orderProcessId: this.orderProcess?.id,
                orderProcessDescription: this.orderProcess?.description,
                previousStatusId: this.orderProcess?.statusId,
                machineId: this.orderProcess?.machineId
            }
        });

        modal.componentInstance?.emitService.subscribe(async (response: ProductionOrderProcessDto) => {
            this.modalPauseOpened = false;

            if (!response) {
                return;
            }

            if (!response.productionPauses) {
                throw new Error('There is no production pauses in the response');
            }

            const pause: ProductionPauseDto = response.productionPauses.find((p: ProductionPauseDto) => !p.endDate) as ProductionPauseDto;

            if (!pause) {
                this.toast.error('Error al crear la pausa');
                return;
            }

            this.currentPause = pause;

            this.timer.stop();

            this.toast.success('Pausa realizada');
        });
    }

    async showStartProductionDialog(): Promise<boolean> {
        return new Promise((resolve) => {
            this.modalService.confirm({
                nzTitle: '<i>¿Seguro que quieres iniciar la producción?</i>',
                nzContent: '<b>Una vez iniciada no podrás editar la orden de producción</b>',
                nzClosable: false,
                nzOkText: 'Iniciar producción',
                nzOnOk: () => { resolve(true); },
                nzCancelText: 'Cancelar',
                nzOnCancel: () => { resolve(false); }
            });
        });
    }

    async showStopProductionDialog(): Promise<boolean> {
        return new Promise((resolve) => {
            this.modalService.confirm({
                nzTitle: '<i>¿Seguro que quieres finalizar la producción?</i>',
                nzContent: '<b>Una vez finalizada no podrás editar la orden de producción</b>',
                nzClosable: false,
                nzOkText: 'Finalizar producción',
                nzOnOk: () => { resolve(true); },
                nzCancelText: 'Cancelar',
                nzOnCancel: () => { resolve(false); }
            });
        });
    }
    //TODO NESTED PROCESSES: check if this function is needed
    async assingPendingSensorValues(): Promise<boolean> {
        return new Promise((resolve) => {
            this.modalService.confirm({
                nzTitle: '<i>Se han detectado valores previos de la máquina que no están asociados a ningún proceso.</i>',
                nzContent: `
            <b>¿Deseas vincular estos valores al proceso actual?</b>
            <br><br>
            <span>
                Si eliges <b>Vincular</b>, los valores se asignarán a este proceso y se tendrán en cuenta en los cálculos de producción.<br>
                Si eliges <b>Omitir</b>, los valores quedarán sin asignar y no se reflejarán en ninguna orden.
            </span>
        `,
                nzClosable: false,
                nzOkText: 'Vincular',
                nzOnOk: () => { resolve(true); },
                nzCancelText: 'Omitir',
                nzOnCancel: () => { resolve(false); }
            });
        });
    }

    async confirmLinkUserToProcess(): Promise<boolean> {
        const previousUserRegisteredId = this.orderProcess?.workingMachinesOnProcesses?.find((wmp) => wmp.machineId === this.orderProcess.machineId)?.currentUserId;

        if (!previousUserRegisteredId) {
            return true;
        }
        const previousUserRegistered = await this.usersService.getById(previousUserRegisteredId)

        return new Promise((resolve) => {
            this.modalService.confirm({
                nzTitle: `<i>¿${this.userLogged?.name} ${this.userLogged?.surname} seguro que quieres vincularte al proceso?</i>`,
                nzContent: `Desvincularás del proceso a ${previousUserRegistered.name} ${previousUserRegistered.surname}`,
                nzClosable: false,
                nzOkText: 'Vincularme',
                nzOnOk: () => { resolve(true); },
                nzCancelText: 'Cancelar',
                nzOnCancel: () => { resolve(false); }
            });
        });
    }

    async startProduction() {
        if (this.orderProcess.status?.isStartingStatus) {
            if (!await this.showStartProductionDialog()) {
                return;
            }
        }

        const sensorConfigKey: string = 'productionOrdersProcessesDetail.sensors';

        if (!this.orderProcess.machineId || this.orderProcess.machineId === 9999) { // ToDo: Instead of checking by hardcoded id, set a column with value for "default machine"
            this.toast.error('Has de asignar una máquina para poder iniciar la producción');
            return;
        }

        if (!this.orderProcess.finalProducts || this.orderProcess.finalProducts.length === 0) {
            this.toast.error('Has de asignar un producto final para poder iniciar la producción');
            return;
        }

        if (this.productionTime?.endDate && this.orderProcess.status?.isEndingStatus) {
            this.toast.error('La producción de este proceso ya ha sido finalizada');
            return;
        }
        const productionOrdermultipleMachinesRunningy: ConfigurationDto = await this.configurationService.getConfigurationByKey(this.productionOrdermultipleMachinesRunning);
        if (this.machineProcess?.state === MachineStatesEnum.RUNNING && productionOrdermultipleMachinesRunningy.value === 'false') {
            this.toast.error('La máquina está en uso');
            return;
        }

        const configValue: ConfigurationDto = await this.configurationService.getConfigurationByKey(sensorConfigKey);
        const runWithSensors: boolean = JSON.parse(configValue.value.toString().toLowerCase());

        if (runWithSensors) {
            // Familias de artículos que no requieren estar cargadas para iniciar el proceso
            const skipLoadValidationFamilies = ['TINTA'];

            for (const rawMaterialToUse of this.orderProcess.rawMaterialsToUse) {
                const articleFamilyReference = rawMaterialToUse.articleFamily?.externalReference;

                // Si la familia del artículo está en la lista de excepciones, saltar validación
                if (articleFamilyReference && skipLoadValidationFamilies.includes(articleFamilyReference)) {
                    continue;
                }

                const isRawMaterialLoaded = this.orderProcess.rawMaterialsUsed.some(rawMaterialUsed => (rawMaterialUsed.articleId === rawMaterialToUse.article?.id) && rawMaterialUsed.isLoadedOnMachine && rawMaterialUsed.rawMaterialToUseId);

                if (!isRawMaterialLoaded) {
                    const continueAnyway = await new Promise<boolean>((resolve) => {
                        this.modalService.confirm({
                            nzTitle: 'Materia prima no cargada',
                            nzContent: `La materia prima ${rawMaterialToUse.article?.name} no está cargada en la máquina. ¿Deseas continuar aun que no esté cargada?`,
                            nzClosable: false,
                            nzOkText: 'Continuar',
                            nzOnOk: () => { resolve(true); },
                            nzCancelText: 'Cancelar',
                            nzOnCancel: () => { resolve(false); }
                        });
                    });

                    if (!continueAnyway) {
                        return;
                    }
                }
            }

            // Verificar si hay una sesión activa en la máquina antes de iniciar
            const hasSwappedUser = await this.checkAndSwapActiveSessionBeforeStart();

            if (hasSwappedUser === null) {
                // Usuario canceló el proceso de swap
                return;
            }

            await this.productionOrderProcessesService.preStartProcess(this.idOrderProcess);

            this.toast.info('Esperando a que la máquina inicie para que el temporizador se ponga en marcha');
            return;
        }

        this.startRunningProduction();
    }

    /**
     * Finish the production process, return true if the process was finished successfully
     * @returns Promise<boolean>
     */
    async finishProduction(): Promise<boolean> {
        try {
            const stopAction = this.stopAction();
            this.orderProcess = await this.productionOrderProcessesService.setProductionProcessAsFinished(this.order.id, this.idOrderProcess, this.userLogged.id, stopAction);
            //Actualizar las cantidades de materia prima con los valores que están en el mapper de quantitiesConsumedMap
            this.orderProcess.rawMaterialsUsed = this.orderProcess.rawMaterialsUsed.map(rm => {
                const totalUsed = this.quantitiesConsumedMap().get(rm.rawMaterialToUseId!);
                if (totalUsed !== undefined) {
                    rm.rawQuantity = totalUsed;
                }
                return rm;
            });
            await this.productionOrderProcessesService.updateRawMaterialsUsed(this.orderProcess.id!, this.orderProcess.rawMaterialsUsed!);
            this.stopAction.set(null);
            this.productionTime = this.orderProcess.productionTime ?? await this.productionOrderProcessesService.getProductionTimeByOrderProcessId(this.idOrderProcess);

            this.toast.success('Producción finalizada');

            this.velocity.set(0);

            this.timer.stop();

            return true;
        } catch (e: any) {
            this.toast.error(e.message);

            return false;
        }
    }

    async stopButtonAction() {
        if (!(await this.showStopProductionDialog())) {
            return;
        }
        const originalFinalProducts = _.cloneDeep(this.orderProcess.finalProducts ?? []);
        // Lista de IDs de procesos de producción que no requieren finalizar turno
        const processIdsToSkipShiftEnd = [1, 2, 3];
        const requiresShiftEnd = !processIdsToSkipShiftEnd.includes(this.orderProcess.productionProcessId!);

        // Si el proceso NO está en la lista de excepciones, debe finalizar el turno
        const useSensorConfig: ConfigurationDto = await this.configurationService.getConfigurationByKey(this.sensorConfigKey);

        if (useSensorConfig
            && useSensorConfig.type === ConfigurationTypesEnum.BOOLEAN
            && JSON.parse(useSensorConfig.value as string)) {
            const machineState = this.orderProcess.machine?.state;

            if (!machineState) {
                this.toast.error('No se ha proporcionado el estado de la máquina.');
                return;
            }

            const isMachineRunning = machineState === MachineStatesEnum.RUNNING;
            const stopAction = isMachineRunning ? StopActionsEnum.CONTINUE : StopActionsEnum.FINISH;

            this.stopAction.set(stopAction);
        }

        let selectedPackage: number | undefined;

        if (requiresShiftEnd) {
            const packageResult = await this.requestShiftEndPackage();
            if (packageResult === null) {
                this.restoreFinalProductsSnapshot(originalFinalProducts);
                return;
            }
            selectedPackage = packageResult as number | undefined;
            if (selectedPackage) {
                this.applyLocalPackagingFill(selectedPackage);
            }
        }

        const quantityResult = await this.requestQuantityProduced();
        if (!quantityResult) {
            this.restoreFinalProductsSnapshot(originalFinalProducts);
            return;
        }

        this.orderProcess.finalProducts = this.applyQuantityToPackagings(quantityResult.finalProducts);

        if (quantityResult.useTraceability) {
            const continueOperation = await this.requestTraceabilityByOrderProcess();
            if (!continueOperation) {
                this.restoreFinalProductsSnapshot(originalFinalProducts);
                return;
            }

            const persistedFinalProducts = await this.persistFinalProductQuantities(quantityResult.finalProducts);
            this.orderProcess.finalProducts = persistedFinalProducts;
        }

        if (requiresShiftEnd) {
            const ended = await this.endShiftSession(selectedPackage as number);
            if (!ended) {
                this.restoreFinalProductsSnapshot(originalFinalProducts);
                return;
            }
        }

        await this.finishProduction();
    }

    async openSelectFinalProducts() {
        const articles = (await this.articleService.findAll()).articles;
        const articlesBatches = (await this.articleBatchService.findAllBatches()).articlesBatches;
        const modal = this.modalService.create({
            nzContent: ModalSelectFinalProductsComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Seleccionar productos finales - Orden ${this.orderProcess?.id} ${this.orderProcess?.description ? '| ' + this.orderProcess?.description : ''}`,
                articles: articles,
                articlesBatches: articlesBatches,
                productionOrderProcess: this.orderProcess
            }
        });

        modal.componentInstance?.emitService.subscribe(async (finalProducts: FinalProductDto[]) => {
            this.orderProcess.finalProducts = finalProducts;
            const productionOrderProcessIndex = this.order.productionOrderProcesses?.findIndex((p) => p.id === this.orderProcess.id);

            if (productionOrderProcessIndex !== undefined && productionOrderProcessIndex !== -1) {
                this.order.productionOrderProcesses![productionOrderProcessIndex] = this.orderProcess;
            }
        });
    }

    async openFinalProducts() {
        const modal = this.modalService.create({
            nzContent: ModalFinalProductsByOrderProcessComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Productos finales - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                productionOrderProcess: this.orderProcess,
                finalProducts: this.orderProcess.finalProducts,
                rawMaterials: this.orderProcess.rawMaterialsUsed
            }
        });
    }

    async openTraceabilityByOrderProcess(openedFromFinaliseProcess: boolean) {
        const modal = this.modalService.create({
            nzContent: ModalTraceabilityByOrderProcessComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Trazabilidad - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                productionOrderProcess: this.orderProcess,
                finalProducts: this.orderProcess.finalProducts,
                rawMaterials: this.orderProcess.rawMaterialsUsed,
                openedFromFinaliseProcess: openedFromFinaliseProcess
            }
        });

        modal.componentInstance?.emitService.subscribe(continueOperation => {
            modal.close();
            if (continueOperation) {
                this.finishProduction();
            }
        });
    }

    private async requestTraceabilityByOrderProcess(): Promise<boolean> {
        return new Promise((resolve) => {
            const modal = this.modalService.create({
                nzContent: ModalTraceabilityByOrderProcessComponent,
                nzStyle: { width: '90%', top: '15%' },
                nzBodyStyle: { height: '50vh' },
                nzClosable: false,
                nzKeyboard: false,
                nzFooter: null,
                nzMaskClosable: false,
                nzData: {
                    nzTitle: `Trazabilidad - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                    productionOrderProcess: this.orderProcess,
                    finalProducts: this.orderProcess.finalProducts,
                    rawMaterials: this.orderProcess.rawMaterialsUsed,
                    openedFromFinaliseProcess: true
                }
            });

            let resolved = false;

            modal.componentInstance?.emitService.subscribe((continueOperation: boolean) => {
                resolved = true;
                resolve(continueOperation);
                modal.close();
            });

            modal.afterClose.subscribe(() => {
                if (!resolved) {
                    resolve(false);
                }
            });
        });
    }

    private async persistFinalProductQuantities(finalProducts: FinalProductDto[]): Promise<FinalProductDto[]> {
        const finalProductsToUpdate = finalProducts
            .filter(fp => fp.id && fp.quantityProduced != null)
            .map(fp => ({
                id: fp.id!,
                quantityProduced: fp.quantityProduced!
            }));

        if (finalProductsToUpdate.length === 0) {
            return finalProducts;
        }

        const finalProductsById = new Map<number, FinalProductDto>();
        finalProducts.forEach(fp => {
            if (fp.id) {
                finalProductsById.set(fp.id, fp);
            }
        });

        const updatedFinalProducts = await this.finalProductService.updateManyQuantityProduced(finalProductsToUpdate);

        const packagingsToUpdate: PackagingDto[] = [];
        const distributedPackagingsByFinalProductId = new Map<number, PackagingDto[]>();

        updatedFinalProducts.forEach((finalProduct) => {
            if (!finalProduct.id) {
                return;
            }

            const sourceFinalProduct = finalProductsById.get(finalProduct.id);
            if (!sourceFinalProduct?.packagings || sourceFinalProduct.packagings.length === 0) {
                return;
            }

            const distributed = this.distributeQuantityIntoPackagings(sourceFinalProduct, sourceFinalProduct.quantityProduced ?? 0);
            distributedPackagingsByFinalProductId.set(finalProduct.id, distributed);
            packagingsToUpdate.push(...distributed);
        });

        let updatedPackagings: PackagingDto[] = [];
        if (packagingsToUpdate.length > 0) {
            updatedPackagings = await this.packagingsService.updatePackagingsQuantity(packagingsToUpdate);
        }

        const updatedPackagingsById = new Map<number, PackagingDto>();
        updatedPackagings.forEach((packaging) => {
            if (packaging.id) {
                updatedPackagingsById.set(packaging.id, packaging);
            }
        });

        return updatedFinalProducts.map((finalProduct) => {
            if (!finalProduct.id) {
                return finalProduct;
            }

            const distributedPackagings = distributedPackagingsByFinalProductId.get(finalProduct.id);
            if (!distributedPackagings) {
                return finalProduct;
            }

            const mergedPackagings = distributedPackagings.map((packaging) => {
                if (packaging.id && updatedPackagingsById.has(packaging.id)) {
                    return updatedPackagingsById.get(packaging.id)!;
                }
                return packaging;
            });

            return {
                ...finalProduct,
                packagings: mergedPackagings
            };
        });
    }

    private distributeQuantityIntoPackagings(finalProduct: FinalProductDto, quantityProduced: number): PackagingDto[] {
        const packagings = finalProduct.packagings ?? [];
        let remaining = Math.max(0, quantityProduced);
        const hasAuxQuantity = finalProduct.axuliaryQuantityProduced != null;
        const axuliaryQuantityProduced = hasAuxQuantity ? (finalProduct.axuliaryQuantityProduced ?? 0) : 0;
        const auxPerPackage = packagings.length > 0 ? (axuliaryQuantityProduced / packagings.length) : 0;

        return packagings.map((packaging) => {
            const capacity = packaging.packagingType?.quantityPerPackaging ?? 0;

            if (capacity <= 0) {
                return {
                    ...packaging,
                    axuliaryQuantity: hasAuxQuantity ? auxPerPackage : packaging.axuliaryQuantity
                };
            }

            const quantity = Math.max(0, Math.min(capacity, remaining));
            remaining -= quantity;

            return {
                ...packaging,
                quantity,
                axuliaryQuantity: hasAuxQuantity ? auxPerPackage : packaging.axuliaryQuantity
            };
        });
    }

    handleOnTickTimer() {
        if (!this.isQualityControlActivated || this.orderProcess.status?.isEndingStatus || this.showingQualityControl || !this.orderProcess.productionProcess?.qualityControl || !this.orderProcess.finalProducts) {
            return;
        }

        const qualityControlCounter: number | undefined = this.orderProcess.qualityControlCounter;
        const elapsedTimeInSeconds: number = this.timer.get().tick_count;

        if (qualityControlCounter && this.qualityControlPerSeconds > 0 && elapsedTimeInSeconds > (qualityControlCounter + (this.qualityControlPerSeconds))) {
            this.openQualityControlModal(this.orderProcess!.finalProducts!);
            return;
        } else if (qualityControlCounter == null && this.qualityControlPerSeconds > 0 && elapsedTimeInSeconds > this.qualityControlPerSeconds) {
            this.openQualityControlModal(this.orderProcess!.finalProducts!);
            return;
        }

        //TODO: qtp
        /*if (this.qualityControlPerQuantityProduced > 0 && this.qualityControlPerQuantityProduced < this.orderProcess.finalProducts![0].quantityProduced!) {
            this.openQualityControlModal(this.orderProcess!.finalProducts!);
            return;
        }*/
    }

    openQualityControlModal(finalProducts: FinalProductDto[]) {
        this.showingQualityControl = true;
        const modal = this.modalService.create({
            nzContent: ModalQualityControlComponent,
            nzStyle: { width: '90%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Control de calidad - Orden ${this.idOrder} | ${this.orderProcess?.description}`,
                productionOrderProcessId: this.idOrderProcess,
                finalProducts: finalProducts
            }
        });

        modal.componentInstance?.emitService.subscribe(async () => {
            const tickCount: number = this.timer.get().tick_count;

            await this.productionOrderProcessesService.updateQualityControlCounter(tickCount, this.orderProcess.id as number);

            this.orderProcess.qualityControlCounter = tickCount;

            this.order.productionOrderProcesses = this.order.productionOrderProcesses?.map((p) => {
                if (p.id === this.orderProcess.id) {
                    p.qualityControlCounter = tickCount;
                }

                return p;
            });
            this.showingQualityControl = false;
        });
    }

    calculateProgress(): number {
        if (!this.orderProcess.finalProducts) {
            return 0;
        }

        // ToDo: Should be "isQuantityProduced" instead of "isAccumulated"
        const quantityProduced: number = this.orderProcess.machine?.sensors?.find(s => s.isAccumulated)?.value! ?? 0;

        const quantityToProduce = this.orderProcess.finalProducts.reduce((total: any, finalProduct) => {
            return total + (finalProduct.quantityToProduce || 0);
        }, 0);

        // const quantityProduced = this.orderProcess.finalProducts.reduce((total: any, finalProduct) => {
        //     return total + (finalProduct.quantityProduced || 0);
        // }, 0);

        return (quantityProduced === 0 || quantityToProduce === 0) ? 0 : Math.min(100, Math.round((quantityProduced / quantityToProduce) * 100));
    }

    async swapUserInProcess() {
        try {
            if (!this.orderProcess.machineId) {
                this.toast.error('No se puede cambiar el usuario sin una máquina asignada');
                return;
            }

            if (!await this.confirmLinkUserToProcess()) {
                return;
            }

            // Bucle iterativo para cerrar todas las sesiones activas en la máquina
            let continueLoop = true;

            while (continueLoop) {
                // Verificar si hay una sesión activa en la máquina
                let activeSessionData: CheckActiveSessionResponseDto | undefined;
                try {
                    activeSessionData = await this.shiftSessionsService.checkActiveSession(this.orderProcess.machineId);
                } catch (error) {
                    console.error('Error al verificar sesión activa:', error);
                    // Si falla la llamada, salir del bucle y continuar con el inicio de turno
                    break;
                }

                // Si no hay sesión activa, salir del bucle
                if (!activeSessionData?.hasActiveSession) {
                    break;
                }

                // Si la sesión activa es del mismo usuario, misma máquina y mismo proceso, no hacer nada
                const isSameUser = activeSessionData.userId === this.userLogged.id;
                const isSameProcess = activeSessionData.productionOrderProcess?.id === this.orderProcess.id;
                // La máquina ya es la misma porque consultamos por this.orderProcess.machineId
                if (isSameUser && isSameProcess) {
                    // El usuario ya tiene una sesión activa en este mismo proceso
                    this.isCurrentUserAssignedToProcess.set(true);
                    this.hasActiveShiftSession.set(true);
                    this.toast.info('Ya tienes un turno activo en este proceso');
                    return;
                }

                // Hay sesión activa de otro usuario o proceso: obtener los paquetes de la orden anterior
                const packagesSource = activeSessionData.productionOrderProcess?.finalProducts;

                // Estructura del backend: finalProducts[].finalProduct.packagings[].packaging
                const availablePackages: PackagingDto[] = packagesSource
                    ?.map((fp: any) => fp.finalProduct?.packagings)
                    .flat(1)
                    .map((wrapper: any) => wrapper?.packaging)
                    .filter((pkg): pkg is PackagingDto => pkg !== undefined) ?? [];

                // Abrir modal para mostrar info de sesión activa y seleccionar paquete
                const result = await this.openScanRawMaterialModal(this.basicRawMaterial, activeSessionData, availablePackages);

                if (!result) {
                    // Usuario canceló, salir completamente
                    return;
                }

                const selectedPackage = result.selectedPackage;
                const previousOrderProcessId = activeSessionData.productionOrderProcess?.id;

                // Llamar al servicio para finalizar la sesión anterior
                // Usar swapUserWithPreviousProcess cuando hay un proceso anterior que cerrar
                let isSwapped: boolean;
                if (previousOrderProcessId) {
                    isSwapped = await this.productionOrderProcessesService.swapUserWithPreviousProcess(
                        this.orderProcess.machineId,
                        this.orderProcess.id as number,
                        selectedPackage as number,
                        previousOrderProcessId
                    );
                } else {
                    isSwapped = await this.productionOrderProcessesService.swapUserInProcess(
                        this.orderProcess.machineId,
                        this.orderProcess.id as number,
                        selectedPackage as number
                    );
                }

                if (!isSwapped) {
                    this.toast.error('No se pudo finalizar la sesión anterior');
                    return;
                }

                this.toast.success(`Sesión de ${activeSessionData.operatorName || 'operario anterior'} finalizada`);

                // Sesión anterior cerrada y nueva sesión creada por el backend
                this.isCurrentUserAssignedToProcess.set(true);
                this.hasActiveShiftSession.set(true);
                this.toast.success('Turno iniciado correctamente');
                return;
            }

            // No había sesión activa previa, llamar al backend para crear la sesión del usuario actual
            const isSwapped = await this.productionOrderProcessesService.swapUserInProcess(
                this.orderProcess.machineId,
                this.orderProcess.id as number,
                undefined as unknown as number
            );

            if (!isSwapped) {
                this.toast.error('No se pudo iniciar el turno');
                return;
            }

            this.isCurrentUserAssignedToProcess.set(true);
            this.hasActiveShiftSession.set(true);
            this.toast.success('Turno iniciado correctamente');

        } catch (error: any) {
            this.toast.error(`Error al iniciar el turno: ${error.message}`);
        }
    }

    formatEstimatedTime(): string {
        let totalSeconds = Math.round(this.estimatedTime());
        if (!isFinite(totalSeconds) || isNaN(totalSeconds)) {
            totalSeconds = 0;
        }
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const parts = [];
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0 || hours > 0) parts.push(`${minutes}min`);
        parts.push(`${seconds}s`);
        return parts.join(' ');
    }

    openScanRawMaterialModal(plainRawMaterial: PlainRawMaterial, activeSessionData?: CheckActiveSessionResponseDto, packagesToUse?: PackagingDto[]): Promise<any> {
        // Si se pasan paquetes específicos, usarlos; si no, usar los de la orden actual
        const availablePackages = packagesToUse ?? this.orderProcess.finalProducts?.map(fp => fp.packagings).flat(1) ?? [];

        // Si el proceso actual o el proceso de la sesión activa es MML (Flexografía/Laminado/Rebobinado) -> saltar modal
        const currentProcessName = this.orderProcess?.productionProcess?.name;
        const previousProcessName = activeSessionData?.productionOrderProcess?.productionProcess?.name;
        if (isMmlProcessName(currentProcessName) || isMmlProcessName(previousProcessName)) {
            // Para procesos MML no es necesario seleccionar paquete, continuar sin mostrar modal
            return Promise.resolve({ selectedPackage: undefined });
        }

        return new Promise((resolve) => {
            const modal = this.modalService.create({
                nzContent: ModalScanRawMaterialComponent,
                nzTitle: 'Escanear materia prima',
                nzWidth: '600px',
                nzFooter: null,
                nzClosable: false,
                nzKeyboard: false,
                nzMaskClosable: false,
                nzData: {
                    previousArticleId: plainRawMaterial.article?.id,
                    processStatusId: this.orderProcess?.statusId,
                    orderProcessId: this.orderProcess?.id,
                    userId: this.userLoggedService.userLogged.id,
                    availablePackages: availablePackages,
                    showOnlyLastPackage: true,
                    activeSessionData: activeSessionData
                }
            });

            modal.afterClose.subscribe((result: any) => {
                resolve(result);
            });
        });
    }

    private async startRunningProduction() {
        try {
            if (!this.timeLoaded) {
                return;
            }

            let infoMessage: string = '';

            if (this.currentPause?.id && this.currentPause?.id > 0) {
                const params: SetEndDateParams = {
                    pauseId: this.currentPause?.id,
                    resumedById: this.userLogged.id,
                    productionOrderProcessId: this.idOrderProcess
                };

                this.orderProcess = await this.productionOrderProcessesService.setOrderProcessAsResumed(params);
                this.currentPause = null;

                infoMessage = 'Producción reanudada';
            } else if (this.orderProcess.status?.isStartingStatus) {
                this.orderProcess = await this.productionOrderProcessesService.setProductionProcessAsStarted(this.order.id, this.idOrderProcess, this.userLogged.id);
                infoMessage = 'Producción iniciada';
            } else {
                this.toast.error('No se puede iniciar la producción');
                return;
            }

            this.timer.resume();
            this.processInitiated = true;

            this.toast.success(`${infoMessage}`);
        } catch (e: any) {
            let toastErrorMessage = '';

            if (e.status === CustomErrorStatusesEnum.ALREADY_EXIST_PRODUCTION_TIME) {
                toastErrorMessage = 'La producción ya ha sido iniciada';
            } else if (e.status === CustomErrorStatusesEnum.PARENT_PROCESS_NOT_FINISHED) {
                toastErrorMessage = 'El proceso anterior no ha sido finalizado';
            } else {
                toastErrorMessage = `Error al iniciar la producción. Error: ${e.message}`;
            }

            this.toast.error(toastErrorMessage);
        }
    }

    /**
     * Verifica si hay una sesión activa en la máquina y gestiona el swap si es necesario.
     * @returns true si se hizo swap, false si no había sesión activa, null si el usuario canceló
     */
    private async checkAndSwapActiveSessionBeforeStart(): Promise<boolean | null> {
        if (!this.orderProcess.machineId) {
            return false;
        }

        try {
            const activeSessionData = await this.shiftSessionsService.checkActiveSession(this.orderProcess.machineId);

            if (!activeSessionData?.hasActiveSession) {
                // No hay sesión activa, se puede iniciar normalmente
                return false;
            }

            // Verificar si la sesión activa es del mismo usuario en el mismo proceso
            const isSameUser = activeSessionData.userId === this.userLogged.id;
            const isSameProcess = activeSessionData.productionOrderProcess?.id === this.orderProcess.id;

            if (isSameUser && isSameProcess) {
                // El usuario ya tiene sesión en este proceso, no hace falta swap
                this.isCurrentUserAssignedToProcess.set(true);
                this.hasActiveShiftSession.set(true);
                return true;
            }

            // Hay sesión activa de otro usuario o proceso: obtener los paquetes de la orden anterior
            const packagesSource = activeSessionData.productionOrderProcess?.finalProducts;

            const availablePackages: PackagingDto[] = packagesSource
                ?.map((fp: any) => fp.finalProduct?.packagings)
                .flat(1)
                .map((wrapper: any) => wrapper?.packaging)
                .filter((pkg): pkg is PackagingDto => pkg !== undefined) ?? [];

            // Abrir modal para mostrar info de sesión activa y seleccionar paquete
            const result = await this.openScanRawMaterialModal(this.basicRawMaterial, activeSessionData, availablePackages);

            if (!result) {
                // Usuario canceló
                return null;
            }

            const selectedPackage = result.selectedPackage;
            const previousOrderProcessId = activeSessionData.productionOrderProcess?.id;

            // Llamar al servicio para finalizar la sesión anterior e iniciar la nueva
            let isSwapped: boolean;
            if (previousOrderProcessId) {
                isSwapped = await this.productionOrderProcessesService.swapUserWithPreviousProcess(
                    this.orderProcess.machineId,
                    this.orderProcess.id as number,
                    selectedPackage as number,
                    previousOrderProcessId
                );
            } else {
                isSwapped = await this.productionOrderProcessesService.swapUserInProcess(
                    this.orderProcess.machineId,
                    this.orderProcess.id as number,
                    selectedPackage as number
                );
            }

            if (!isSwapped) {
                this.toast.error('No se pudo finalizar la sesión anterior');
                return null;
            }

            this.toast.success(`Sesión de ${activeSessionData.operatorName || 'operario anterior'} finalizada`);
            this.isCurrentUserAssignedToProcess.set(true);
            this.hasActiveShiftSession.set(true);

            return true;

        } catch (error) {
            console.error('Error al verificar sesión activa:', error);
            // Si falla la verificación, permitir continuar con el inicio normal
            return false;
        }
    }

    private async setTimer() {
        try {
            if (this.orderProcess.productionPauses) {
                this.currentPause = this.orderProcess.productionPauses.find((p) => !p.endDate) ?? null;
            }

            await this.setStartTime();

            if (this.orderProcess.statusId !== StatusEnum.AWAITING) {
                this.productionTime = this.orderProcess.productionTime ?? await this.productionOrderProcessesService.getProductionTimeByOrderProcessId(this.idOrderProcess);
            }

            this.timer.start();

            if (
                this.orderProcess.statusId === StatusEnum.AWAITING
                || this.orderProcess.statusId === StatusEnum.PAUSED
                || this.orderProcess.statusId === StatusEnum.FINISHED
                || this.orderProcess.statusId === StatusEnum.CANCELLED
            ) {
                this.timer.stop();
            }

            this.timeLoaded = true;
        } catch (error: any) {
            this.toast.error('Error estableciendo timer:' + error.message);
        }
    }

    private async setStartTime() {
        const currentTimeMilliseconds: number = await this.productionOrderProcessesService.getTimerByProductionOrderProcessId(this.idOrderProcess);

        if (currentTimeMilliseconds > 0) {
            this.timer.startTime = Math.max(0, Math.round((currentTimeMilliseconds / 1000 + Number.EPSILON) * 100) / 100 - 1);
            this.processInitiated = true;
        } else {
            this.timer.startTime = 0;
        }

        return currentTimeMilliseconds;
    }

    private async handleTimerAndStatus() {
        if (!this.timer) {
            return;
        }

        if (this.orderProcess.productionPauses) {
            this.currentPause = this.orderProcess.productionPauses.find((p) => !p.endDate) ?? null;
        }

        const { status } = this.orderProcess;

        if (status?.id === StatusEnum.IN_PROGRESS) {
            await this.setStartTime();
            this.timer.start();
            this.timeLoaded = true;
        } else if (status?.isPauseStatus || status?.isEndingStatus) {
            await this.timer.stop();
        }
    }

    private async requestQuantityProduced(): Promise<{ finalProducts: FinalProductDto[], useTraceability: boolean } | null> {
        const productionOrderFinalQuantity: ConfigurationDto = await this.configurationService.getConfigurationByKey(this.productionOrderFinalQuantity);

        if (productionOrderFinalQuantity.value === 'true') {
            return {
                finalProducts: this.orderProcess.finalProducts ?? [],
                useTraceability: false
            };
        }

        this.applyDefaultQuantityFromPackagings();

        return new Promise((resolve) => {
            const modal = this.modalService.create({
                nzContent: ModalQuantityProducedComponent,
                nzStyle: { width: '70%', top: '20%' },
                nzBodyStyle: { height: '30vh' },
                nzClosable: false,
                nzKeyboard: false,
                nzFooter: null,
                nzMaskClosable: false,
                nzData: {
                    nzTitle: `Indica la cantidad final de artículos producidos para la orden ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                    finalProducts: this.orderProcess.finalProducts,
                    productionProcessName: this.orderProcess.productionProcess?.name
                }
            });

            let resolved = false;

            modal.componentInstance?.emitService.subscribe((updatedFinalProducts: FinalProductDto[]) => {
                resolved = true;
                resolve({ finalProducts: updatedFinalProducts, useTraceability: true });
            });

            modal.afterClose.subscribe(() => {
                if (!resolved) {
                    resolve(null);
                }
            });
        });
    }

    private async requestShiftEndPackage(): Promise<number | undefined | null> {
        const availablePackages = this.orderProcess.finalProducts?.map(fp => fp.packagings).flat(1) ?? [];

        if (availablePackages.length === 0) {
            return undefined;
        }

        const result = await this.openScanRawMaterialModal(this.basicRawMaterial);

        if (!result) {
            return null;
        }

        return result.selectedPackage as number;
    }

    private applyLocalPackagingFill(selectedPackageId: number): void {
        const finalProduct = this.orderProcess.finalProducts?.find(fp => fp.packagings?.some(pkg => pkg.id === selectedPackageId));

        if (!finalProduct?.packagings || finalProduct.packagings.length === 0) {
            return;
        }

        const selectedIndex = finalProduct.packagings.findIndex(pkg => pkg.id === selectedPackageId);
        if (selectedIndex < 0) {
            return;
        }

        finalProduct.packagings = finalProduct.packagings.map((packaging, index) => {
            const capacity = packaging.packagingType?.quantityPerPackaging ?? 0;
            if (capacity <= 0) {
                return packaging;
            }

            const quantity = index <= selectedIndex ? capacity : 0;

            return {
                ...packaging,
                quantity
            };
        });

        finalProduct.quantityProduced = finalProduct.packagings.reduce((total, packaging) => total + (packaging.quantity ?? 0), 0);
    }

    private applyQuantityToPackagings(finalProducts: FinalProductDto[]): FinalProductDto[] {
        return finalProducts.map((finalProduct) => {
            if (!finalProduct.packagings || finalProduct.packagings.length === 0) {
                return finalProduct;
            }

            return {
                ...finalProduct,
                packagings: this.distributeQuantityIntoPackagings(finalProduct, finalProduct.quantityProduced ?? 0)
            };
        });
    }

    private restoreFinalProductsSnapshot(snapshot: FinalProductDto[]): void {
        this.orderProcess.finalProducts = _.cloneDeep(snapshot);
    }

    private applyDefaultQuantityFromPackagings(): void {
        if (!this.orderProcess.finalProducts || this.orderProcess.finalProducts.length === 0) {
            return;
        }

        this.orderProcess.finalProducts.forEach((finalProduct) => {
            const packagings = finalProduct.packagings ?? [];
            if (packagings.length === 0) {
                return;
            }

            const totalPackagingQuantity = packagings.reduce((total, packaging) => total + (packaging.quantity ?? 0), 0);
            if (totalPackagingQuantity > 0) {
                finalProduct.quantityProduced = totalPackagingQuantity;
            }
        });
    }

    private async endShiftSession(selectedPackage?: number): Promise<boolean> {
        try {
            await this.productionOrderProcessesService.endShiftSession(this.idOrderProcess, this.userLogged.id, selectedPackage as number);

            // Ambos estados a false: ya no está en la máquina ni tiene turno activo
            this.isCurrentUserAssignedToProcess.set(false);
            this.hasActiveShiftSession.set(false);
            this.toast.success('Turno finalizado correctamente');
            return true;
        } catch (error: any) {
            this.isCurrentUserAssignedToProcess.set(false);
            this.hasActiveShiftSession.set(false);
            this.toast.error(JSON.stringify(getLastError(error)));
            return false;
        }
    }

    private getNzTitle(): string {

        if (this.idColumnValueToShow === 'id') {
            this.idValueToShow = this.idOrder.toString();
        } else if (this.idColumnValueToShow === 'externalId') {
            this.idValueToShow = this.order.externalId?.toString() ?? '';
        } else if (this.idColumnValueToShow === 'finalProduct') {
            this.idValueToShow = this.getIdColumnValue();
        } else {
            this.idValueToShow = '-';
        }

        const processDesc = this.orderProcess?.description ?? '';

        return `Orden ${this.idValueToShow} | ${processDesc} -`;
    }

    private getIdColumnValue(): string {
        return this.orderProcess &&
            this.orderProcess?.finalProducts?.[0]?.articleBatch?.batchNumber || '';
    }

    private loadMultiplier() {
        this.orderProcess.machine?.machineMeasurementsValues?.forEach((measurementValue) => {
            if (measurementValue.machineMeasurement?.measurement === MachineMeasurementsEnum.MULTIPLIER
                && measurementValue.articleId === this.orderProcess.finalProducts?.[0]?.article?.id
            ) {
                this.multiplier.set(Number(measurementValue.value) ?? 1);
            }
        })
    }

    private checkUserAssignmentToProcess(orderProcess: ProductionOrderProcessDto) {

        if (!orderProcess || !orderProcess.machineId) {
            return;
        }

        // 1. Verificar si el usuario está en la tabla workingMachinesOnProcesses
        let userIdRegistredInMachine = null;
        orderProcess.workingMachinesOnProcesses?.find((workingMachine) => {
            if (workingMachine.machineId === orderProcess.machineId && orderProcess.id === workingMachine.productionOrderProcessId) {
                userIdRegistredInMachine = workingMachine.currentUserId;
            }
        })

        const isUserInMachine = this.userLogged.id === userIdRegistredInMachine;
        this.isCurrentUserAssignedToProcess.set(isUserInMachine);

        // 2. Verificar si el usuario tiene un turno activo (shiftSession abierta)
        this.checkActiveShiftSession(orderProcess);

    }

    /**
     * Verifica si el usuario actual tiene una sesión de turno activa
     *
     * IMPORTANTE: Esta verificación es independiente de workingMachinesOnProcesses
     * - workingMachinesOnProcesses: indica qué usuario está activo en la máquina
     * - activeShiftSessions: indica qué usuarios tienen turnos abiertos
     *
     * Ambas condiciones deben cumplirse para mostrar "Finalizar turno"
     */
    private checkActiveShiftSession(orderProcess: ProductionOrderProcessDto) {
        if (!orderProcess || !orderProcess.shiftSessions || orderProcess.shiftSessions.length === 0) {
            this.hasActiveShiftSession.set(false);
            return;
        }

        // Buscar si existe una sesión activa para el usuario actual
        const hasActiveSession = orderProcess.shiftSessions.some((session) =>
            session.userId === this.userLogged.id &&
            session.productionOrderProcessId === orderProcess.id &&
            !session.endDate // La sesión no debe tener fecha de fin
        );

        this.hasActiveShiftSession.set(hasActiveSession);
    }

    async finalSesion(): Promise<boolean> {
        const selectedPackage = await this.requestShiftEndPackage();

        if (selectedPackage === null) {
            return false;
        }

        return this.endShiftSession(selectedPackage as number);
    }

    isConfeccionProcess(): boolean {
        return isUdProcessName(this.orderProcess?.productionProcess?.name);
    }

    openPackagingDestinationTypeModal() {
        if (!this.isGenerateNewLabelButtonEnabled) {
            this.toast.info('Desactivado por el administrador.');
            return;
        }

        // const modal = this.modalService.create({
        //     nzTitle: 'Seleccionar destino de etiqueta',
        //     nzContent: ModalSelectPackagingDestinationComponent,
        //     nzClosable: true,
        //     nzKeyboard: false,
        //     nzFooter: null,
        // });

        // const instance = modal.getContentComponent() as ModalSelectPackagingDestinationComponent;
        // instance?.destinationTypeSelected.subscribe(async (destinationType: PackagingDestinationTypeEnum) => {
        //     modal.close();
        //     await this.requestNewPackagingBatchFromVelneo(destinationType);
        // });
    }

    async openPalletListModal() {
        try {
            this.toast.info('Buscando palets...');

            // 1. Try to get pallets from MES DB (packagingOnPackagings)
            let pallets = await this.packagingsService.getPalletsByProcessId(this.idOrderProcess);

            // 2. If no pallets in DB, fallback to Samarplast connector
            if (!pallets || pallets.length === 0) {
                const externalId = this.order?.externalId;
                if (externalId) {
                    pallets = await this.packagingsService.consultPallets(externalId);

                    // Refrescar el proceso de orden emitiendo al BehaviorSubject
                    // para que la suscripción en ngOnInit actualice toda la vista
                    await this.productionOrderProcessesService.refreshOrderProcess(this.idOrderProcess);
                }
            }

            // 3. If still no pallets, show warning toast
            if (!pallets || pallets.length === 0) {
                this.toast.warning('No se encontraron palets para esta orden');
                return;
            }

            // 4. Open modal with pallets
            this.modalService.create({
                nzContent: ModalPalletListComponent,
                nzStyle: { width: '80%', maxWidth: '1200px', top: '10%' },
                nzBodyStyle: { maxHeight: '70vh', overflow: 'auto' },
                nzClosable: true,
                nzKeyboard: true,
                nzFooter: null,
                nzData: {
                    pallets: pallets,
                    processId: this.idOrderProcess,
                },
            });
        } catch (error: any) {
            this.toast.error(error.message || 'Error al consultar palets');
        }
    }

    private async requestNewPackagingBatchFromVelneo(destinationType: PackagingDestinationTypeEnum) {
        if (!this.isGenerateNewLabelButtonEnabled) {
            this.toast.info('Desactivado por el administrador.');
            return;
        }

        try {
            const finalProduct = this.orderProcess.finalProducts?.[0];
            if (!finalProduct?.id) {
                this.toast.error('No hay producto final asociado al proceso');
                return;
            }

            this.toast.info('Generando etiqueta desde Velneo...');

            const newPackaging = await this.packagingsService.requestNewPackagingBatchFromVelneo(
                this.orderProcess.id!,
                finalProduct.id,
                destinationType
            );

            this.toast.success(`Etiqueta ${newPackaging.batchNumber} generada correctamente`);
            // Socket notification will update the display automatically
        } catch (error: any) {
            this.toast.error(error.message || 'Error generando etiqueta');
        }
    }
}
